import { IOccurrence } from "interfaces/Occurrence";

class LastCoordsAdapter {
  adapt(occurrence: IOccurrence): IOccurrence {
    return Object.assign(occurrence, {
      lastCoords: JSON.parse(occurrence.stringLastCoords ?? "[]"),
      findCoords: JSON.parse(occurrence.stringFindCoords ?? "[]"),
    });
  }
}

export default new LastCoordsAdapter();
